module.exports = __webpack_public_path__ + "img/strategy.2d5adf19.png";